$(document).ready(function(){

  var form = $('.form__ajax');

  form.on('submit', function(e) {
    e.preventDefault();

    // -- variables --
    var $this = $(this);
    var recaptchaSecretKey = '6LcF1f8UAAAAAJ_B4wOm2b6nkpIo2T_asg9-bLXc';

    // -- recaptcha --
    grecaptcha.ready(function() {
      grecaptcha.execute(recaptchaSecretKey, {action: 'submit'}).then(function(token) {
          // Add your logic to submit to your backend server here.
          $this.find('input[name=g-recaptcha-response]').val(token);

          var data = $this.serialize();
          data[csrfTokenName] = csrfTokenValue;

          $.post('actions/recaptcha/siteVerify',data, function(response) {
            var result = $.parseJSON(response);

            // -- Reset notifications --
            $('.form__notifications .error, .form__notifications .success').text('');
            // -- Scroll for notification --
            $('html,body').animate({scrollTop:$('.page__wrapper').offset().top}, 'slow');

            if (result.success == 'true') {
              
              // -- Ajax subission --
              $.post('actions/formBuilder2/entry/submitEntry', data).done(function(data) {

                if (!data.success) {
                  // ERROR

                  // Display notifications
                  $('.form__notifications .error').text(data.customErrorMessage);
                  $('.form__notifications').fadeIn();

                  $.each(data.validationErrors, function(key, value) {
                    // Display errors
                    $('.field--'+key).addClass('error').find('.errors').html('<p>' + value + '</p>');
                    
                    // Update errors
                    $('.field--'+key+' input, .field--'+key+' textarea, .field--'+key+' select').on('change',function(){
                      $('.field--'+key).removeClass('error').find('.errors').fadeOut();
                    });
                  });

                } else {
                  // SUCCESS
                  
                  $('.form__ajax').delay(400).fadeOut();

                  // Display notifications
                  $('.form__notifications .success').text(data.customSuccessMessage);
                  $('.form__notifications').delay(800).fadeIn();
                }
                
              });

            } else {

              // -- ERROR --
              // Display notifications
              $('.form__notifications .error').text(result.customErrorMessage);
              $('.form__notifications').fadeIn();

            }
          }, 'json');
             
        }
      );
    });

  });

});